import { useState } from "react"
import { FEATURE_LABEL } from "../../matter/copy"
import { ABOUT_FEATURES, ABOUT_FILES, ABOUT_SESSIONS, ABOUT_WORKSPACE_NAME } from "../aboutWorkspace"

const idx = (i: number) => ({ "--i": i }) as React.CSSProperties

/**
 * The one scene of the walkthrough, drawn with the app's own classes: the workspace card (nr-wsc), file
 * rows (nmf-row, ncf-badge), feature tags and filters (nms-tag, nms-filter), the ds input and button.
 * `s` is 0 before the tour is in view, then the active step 1-4; every actor reads it from data-s, so the
 * same workspace card persists and evolves while the rest moves around it. Decorative: the captions carry the text.
 */
export function Scene({ s }: { s: number }) {
  const [only, setOnly] = useState<"all" | "research" | "notice">("all")
  const shown = ABOUT_SESSIONS.filter((x) => only === "all" || x.feature === only)
  return (
    <div className="nr wa-scene" data-s={s} aria-hidden="true">
      <ul className="wa-a wa-feats">
        {ABOUT_FEATURES.map((f, i) => (
          <li key={f.feature} className="wa-frow" style={idx(i)}>
            <span className="wa-wire" />
            <span className="nms-tag wa-ftag">{FEATURE_LABEL[f.feature]}</span>
            <span className="nr-wsc-text wa-what">{f.what}</span>
          </li>
        ))}
      </ul>

      <div className="nr-wsc wa-a wa-form">
        <p className="nr-wsc-over">New workspace</p>
        <div className="nr-input wa-input">{ABOUT_WORKSPACE_NAME}</div>
        <div className="nr-wsc-acts"><span className="nr-btn" data-variant="primary" data-size="sm">Create</span></div>
      </div>

      <div className="nr-wsc wa-a wa-card">
        <div className="wa-chead">
          <p className="nr-wsc-over">Workspace</p>
          <div className="wa-counts">
            <span className="nh-recent-d wa-count c1">No files yet</span>
            <span className="nh-recent-d wa-count c2">3 files</span>
            <span className="nh-recent-d wa-count c4">3 files · 3 sessions</span>
          </div>
        </div>
        <p className="nr-wsc-name">{ABOUT_WORKSPACE_NAME}</p>
        <div className="wa-cbody">
          <p className="nr-wsc-text wa-pane wa-p-empty">Files in a workspace are shared by every session in it.</p>
          <ul className="wa-pane wa-p-files">
            {ABOUT_FILES.map((f, i) => (
              <li key={f.name} className="nmf-row wa-file" style={idx(i)}><span className="ncf-badge">{f.kind}</span><span className="nmf-name">{f.name}</span></li>
            ))}
          </ul>
          <div className="wa-pane wa-p-sess">
            <div className="nms-filters wa-filter">
              {(["all", "research", "notice"] as const).map((k) => (
                <button key={k} type="button" tabIndex={-1} className={`nms-filter${only === k ? " on" : ""}`} onClick={() => setOnly(k)}>
                  {k === "all" ? "All" : FEATURE_LABEL[k]}
                </button>
              ))}
            </div>
            <ul className="wa-sessions">
              {shown.map((x, i) => (
                <li key={x.title} className="nms-row wa-session" style={idx(i)}>
                  <span className="nms-t">{x.title}</span>
                  <span className="nms-sub"><span className="nms-tag">{FEATURE_LABEL[x.feature]}</span><span className="nms-date">{x.date}</span></span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <ul className="wa-a wa-drop">
        {ABOUT_FILES.map((f, i) => (
          <li key={f.name} className="nmf-row wa-chipfile" style={idx(i)}><span className="ncf-badge">{f.kind}</span><span className="nmf-name">{f.name}</span></li>
        ))}
      </ul>
    </div>
  )
}
